<template>
    <div>
        <InstrumentRunnerFormFields :processes="schedule.process_schedules" @formFieldsUpdated="setFormFields" />
        <div v-if="formFields && formFields.schedulable_process_id">
            <b-row class="pr-3 mb-2">
                <b-col class="px-0 text-right">
                    <InstrumentRunnerExportButton
                        :export_data="exportData"
                        @newResultExportCreated="refetchExport"
                    />
                </b-col>
            </b-row>
            <ResultExportTable
                v-if="!exports_loading"
                :collection="export_collection"
                @dataRefreshRequest="refetchExport"
            />
        </div>
    </div>
</template>

<script>
import InstrumentRunnerFormFields from './InstrumentRunnerFormFields';
import InstrumentRunnerExportButton from './InstrumentRunnerExportButton.vue';
import ResultExportTable from '../resultexport/ResultExportTable.vue';
import { getCollection } from "@/shared/fetch-utils";

export default {
    name: "InstrumentRunnerBody",
    components: {
    InstrumentRunnerFormFields,
    InstrumentRunnerExportButton,
    ResultExportTable
},
    props: {
        schedule: {
            type: Object,
            required: true,
        },
    },
    computed: {
        exportData() {
            // rename the process_id key
            return {
                ...this.formFields,
                schedulable_process_type: this.schedule.process_type,
                laboratory_id: this.schedule.laboratory_id,
                schedule_id: this.schedule.id,
            };
        },
    },
    data() {
        return {
            formFields: null,
            exports_loading: true,
            export_collection: null,
        };
    },
    methods: {
        setFormFields(fields) {
            this.formFields = fields;
        },
        async fetchExports() {     
            // if enough data is set: fetch exports
            if (
                this.schedule.sample_type_id &&
                this.schedule.process_type &&
                this.formFields.schedulable_process_id
            ) {
                this.export_collection = await getCollection({
                collection_type: "result_export",
                filters: [
                    {
                        logic: "filterEquals",
                        field: "sample_type_id",
                        value: this.schedule.sample_type_id,
                    },
                    {
                        logic: "filterEquals",
                        field: "schedulable_process_type",
                        value: `App\\Models\\${this.schedule.process_type === "Prep" ? this.schedule.process_type : "Test"}Process`,
                    },
                    {
                        logic: "filterEquals",
                        field: "schedulable_process_id",
                        value: this.formFields.schedulable_process_id,
                    },
                    {
                        logic: "filterEquals",
                        field: "schedule_id",
                        value: this.schedule.id
                    }
                ],
                sort: [
                    {
                    logic: "sortAddDesc",
                    field: "created_at",
                    },
                ],
                });

                // set loading flag
                this.exports_loading = false;
            } else {
                // reset collection to null - there is not enough info
                this.export_collection = null;
            }
        },
        refetchExport() {
            this.fetchExports();
        }
    },
    watch: {
        formFields: {
            handler() {
                this.fetchExports();
            },
            deep: true,
            immediate: false,
        }
    }
}
</script>
